module.exports = __webpack_public_path__ + "static/media/fondo_solista.117213bd.jpg";